import {
  CgCustomDomainHostnameError,
  parseCgCustomDomainHostname,
} from '@provision/landing-page-utils';
import { splitHostname } from './cg-custom-domain-display';

/** The address we suggest on a domain: a subdomain, since the root of a domain can't point to us. */
export const suggestHostname = (apex: string): string => `membership.${apex}`;

interface ParsedCustomDomainHostname {
  hostname: string;
  apex: string | null;
  error: string | null;
}

export function parseCustomDomainHostname(
  raw: string,
  exampleApex: string,
): ParsedCustomDomainHostname {
  const { hostname, error } = parseCgCustomDomainHostname(raw);

  if (!hostname) return { hostname, apex: null, error: null };

  if (error === CgCustomDomainHostnameError.RootDomain) {
    return {
      hostname,
      apex: null,
      error: `Use a subdomain, like ${suggestHostname(hostname)}. The root of a domain can't point to us.`,
    };
  }

  if (error) {
    return {
      hostname,
      apex: null,
      error: `Enter an address like ${suggestHostname(exampleApex)}.`,
    };
  }

  return { hostname, apex: splitHostname(hostname).apex, error: null };
}

export function getEmailDomainWarning(
  apex: string | null,
  emailDomains: string[],
): string | null {
  if (!apex || !emailDomains.length || emailDomains.includes(apex)) return null;

  return `${apex} isn’t one of your email domains (${emailDomains.join(', ')}). That’s fine if you own it.`;
}
